import { render, staticRenderFns } from "./task.vue?vue&type=template&id=380313a5&scoped=true"
import script from "./task.vue?vue&type=script&lang=js"
export * from "./task.vue?vue&type=script&lang=js"
import style0 from "./task.vue?vue&type=style&index=0&id=380313a5&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380313a5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380313a5')) {
      api.createRecord('380313a5', component.options)
    } else {
      api.reload('380313a5', component.options)
    }
    module.hot.accept("./task.vue?vue&type=template&id=380313a5&scoped=true", function () {
      api.rerender('380313a5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/task/task.vue"
export default component.exports